module.exports = __webpack_public_path__ + "static/media/4645.a5637de3.jpg";